<template>
  <el-form-item
    :label="label"
    class="date"
    :prop="prop"
    :rules="rules"
    :required="required"
  >
    <el-date-picker
      v-model="date"
      type="date"
      format="yyyy/MM/dd"
      value-format="yyyy/MM/dd"
      :picker-options="datePickerOptions"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      @change = "changeDate"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: Date,
    label: String,
    prop: {
      type: String,
      default: 'Date'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    limit: {
      type: String,
      default: ''
    },
    limitDate: {
      type: String,
      defalt: ''
    }
  },
  data () {
    return {
      datePickerOptions: {}
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (date) {
        this.$emit('input', date)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
    const inner = this.$el.querySelector('.el-input__inner')
    inner.setAttribute('maxlength', '10')
    this.changeDate()
  },
  methods: {
    changeDate () {
      this.datePickerOptions = Object.assign({}, this.datePickerOptions, {
        disabledDate: (date) => {
          var result = false
          if (this.limit === 'from') {
            result = (date > new Date(this.limitDate))
          }
          if (this.limit === 'to') {
            result = (date < new Date(this.limitDate))
          }
          return result
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
